<template lang="pug">
    model-data-table(
        no-data-text='Sin prestamos.'
        no-search
        ref='table'
        remind-key='employyee-loan-company-list'
        v-bind='tableProps' 
        @detail='submitDetail' 
        @remove='submitRemove' 
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelDataTable } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import EmployeeLoanCompanyModel from '@/models/HumanResource/HrEmployeeLoanCompany'
    import EmployeeLoanCompanyFilters from '@/views/HumanResource/HrEmployeeLoanCompany/HrEmployeeLoanCompanyFilters'
    import EmployeeLoanCompanyHeaders from '@/views/HumanResource/HrEmployeeLoanCompany/HrEmployeeLoanCompanyHeaders'
    //
    export default {
        name: 'employee-loan-company-create',
        components: {
            ModelDataTable,
        },
        computed: {

            /**
             *
             */
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             *
             */
            tableProps() {
                return {
                    filters: EmployeeLoanCompanyFilters,
                    headers: EmployeeLoanCompanyHeaders,
                    service: EmployeeLoanCompanyModel,
                }
            },
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             *
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(EmployeeLoanCompanyModel, error.response.data))
            },

            /**
             * 
             */
            refresh() {
                this.$refs.table.refresh()
            },

            /**
             * 
             */
            submitCreate() {
                this.$router.push({ name: 'employee-loan-company-create' })
            },

            /**
             * 
             */
            submitDetail(event) {
                this.$router.push({ 
                    name: 'employee-loan-company-update', 
                    params: { 
                        id: event.item.id
                    }
                })
            },

            /**
             * 
             */
            submitRemove(event) {

                //
                this.setWarningSnackbar({
                    title: '¿Esta seguro en eliminar el prestamo seleccionado?',
                    message: 'Una vez eliminado no se puede recuperar.',
                    confirm: 'eliminar',
                })

                //
                this.selected = event.item
            },

            /**
             * 
             */
            successRemove() {
                this.setSuccessSnackbar('Prestamo eliminado exitosamente.')
            },

            /**
             * 
             */
            toRemove() {
                this.selected
                    .delete()
                    .then(this.successRemove)
                    .then(this.refresh)
                    .catch(this.error)
            }
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch(val) {
                    case 'eliminar': return this.toRemove()
                }
            }
        },
        mounted() {
            this.setTitleTopBar('Prestamos de compañia')
            this.setItemsTopBar([
                {
                    text: 'agregar prestamo',
                    icon: 'add_circle',
                    action: this.submitCreate,
                }
            ])
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
            })
        },
    }
</script>
